var _style, _title, _desc, _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFigma = function SvgFigma(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "60 -50 400 400",
    width: 90,
    height: 90,
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#0acf83}.st1{fill:#a259ff}.st2{fill:#f24e1e}.st3{fill:#ff7262}.st4{fill:#1abcfe}")), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Figma.logo")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    className: "st0",
    d: "M50 300c27.6 0 50-22.4 50-50v-50H50c-27.6 0-50 22.4-50 50s22.4 50 50 50z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    className: "st1",
    d: "M0 150c0-27.6 22.4-50 50-50h50v100H50c-27.6 0-50-22.4-50-50z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path1_fill_1_",
    className: "st2",
    d: "M0 50C0 22.4 22.4 0 50 0h50v100H50C22.4 100 0 77.6 0 50z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path2_fill",
    className: "st3",
    d: "M100 0h50c27.6 0 50 22.4 50 50s-22.4 50-50 50h-50V0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path3_fill",
    className: "st4",
    d: "M200 150c0 27.6-22.4 50-50 50s-50-22.4-50-50 22.4-50 50-50 50 22.4 50 50z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFigma, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/figma.8f05871e.svg";
export { ForwardRef as ReactComponent };